import React from "react"
import PropTypes from "prop-types"
import { Row, Col } from "react-bootstrap"
import { range } from "lodash"

const props = {
  n: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired
}

const defaults = {
  n: 2,
  className: ""
}

const Columns = ({ n, children, className }) => (
  <Row className={className}>
    {
      range(n).map(i => (
        <Col md={12 / n} key={i}>
          <div>
            { children.filter((ignored, j) => (j % n == i)) }
          </div>
        </Col>
      ))
    }
  </Row>
)

Columns.propTypes = props
Columns.defaultProps = defaults

export default Columns